import { render } from "./QuestionsCarousel.vue?vue&type=template&id=145ac015&scoped=true"
const script = {}

import "./QuestionsCarousel.vue?vue&type=style&index=0&id=145ac015&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145ac015"]])

export default __exports__